import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { Link } from 'react-router-dom'
import { ListItem } from '@material-ui/core'
import CustomCommonContext from '../../../../custom/context/common/commonContext'
import { useTheme } from '@material-ui/core/styles'
import i18next from 'i18next'

const LanguageSwitch = () => {
    const customCommonContext = useContext(CustomCommonContext)
    const { languages } = customCommonContext

    const [anchorEl, setAnchorEl] = useState(null)
    const [currFlag, setCurrFlag] = useState('/assets/svg/usFlag.svg')
    const [language, setLanguage] = useState({
        id: 0,
        label: 'English',
        img: currFlag,
        code: 'for_english',
    })
    const [languageArray, setLanguageArray] = useState([])
    const { i18n } = useTranslation()
    const theme = useTheme()

    const toCab = (data) => data.toString().charAt(0).toUpperCase() + data.slice(1)
    useEffect(() => {
        let temp = []
        if (languages)
            languages.forEach((element, index) => {
                temp.push({
                    id: index,
                    label: toCab(element.replace('for_', '')),
                    img: currFlag,
                    code: element,
                })
            })
        setLanguageArray(temp)
    }, [languages, currFlag])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = (event) => {
        setAnchorEl(null)
    }

    const changeLanguage = (id, label, img, code) => {
        setLanguage({
            id: id,
            label: label,
            img: currFlag,
            code,
        })
        i18n.changeLanguage(code)

        if (code === 'for_arabic') {
            document.body.dir = 'rtl'
            theme.direction = 'rtl'
            setCurrFlag('/assets/svg/usFlag.svg')
        } else {
            document.body.dir = 'ltr'
            theme.direction = 'ltr'
            setCurrFlag('/assets/svg/uaeFlag.svg')
        }

        handleClose()
    }

    return (
        <div className="languageSwitch">
            <Link to="#" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                <img src={language.img}></img>
                {language.label}
            </Link>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                className={`langDropMenu ${document.body.dir === 'rtl' && 'rtl'}`}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {languageArray
                    .filter((x) => x.id !== language.id)
                    .map((data, index) => (
                        <ListItem
                            button
                            key={index}
                            className="languageMenu"
                            onClick={() => changeLanguage(data.id, data.label, currFlag, data.code)}
                        >
                            <img src={currFlag}></img>
                            {data.label}
                        </ListItem>
                    ))}
            </Menu>
            {console.log(languageArray, 'languageArray')}
        </div>
    )
}
export default LanguageSwitch
